module.exports = __webpack_public_path__ + "static/mm-0be7f8f149978fdffe02201dbd8a9e28.png";